import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CW, InfoHint, PageTitle, Panel } from "./cwUi";

/**
 * Formerly global check-in settings. Late submit + day change are now
 * per journey (Add/Edit Tracker → Check-in Configuration, or journey →
 * Check-in rules). This page stays as a pointer so old bookmarks/nav
 * still land somewhere useful.
 */

export default function CheckInSettingsPage() {
  const navigate = useNavigate();

  return (
    <div className="container-fluid">
      <Box sx={{ maxWidth: 900, mx: "auto", pb: 6 }}>
        <PageTitle>
          Check-in settings
          <InfoHint id="settings.checkin" />
        </PageTitle>
        <Typography sx={{ fontSize: 13.5, color: CW.muted, mb: 2 }}>
          These options are set on each journey, not for the whole gym.
        </Typography>

        <Panel>
          <Alert severity="info" sx={{ mb: 2 }}>
            Late submit and change check-in day are configured per journey:
            open a tracker → Edit → Check-in Configuration, or use Check-in
            rules on that journey.
          </Alert>
          <Typography sx={{ fontSize: 14, color: CW.ink, mb: 1.5 }}>
            Per journey you can turn on or off:
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5, color: CW.muted, fontSize: 13.5 }}>
            <li>Members can submit a missed check-in late (default On)</li>
            <li>Coaches can change a client&apos;s check-in day (default Off)</li>
          </Box>
          <Box sx={{ display: "flex", gap: 1, mt: 2.5, flexWrap: "wrap" }}>
            <button
              type="button"
              className="small-contained-button"
              onClick={() => navigate("/trackers")}
            >
              Open trackers
            </button>
          </Box>
        </Panel>
      </Box>
    </div>
  );
}
